module.exports = __webpack_public_path__ + "img/product-chuti-qt-02.62ae631d.png";